export enum DraftStatuses {
    Unknown = 0,
    WaitingForMapBans = 0,
    WaitingForMapVotes = 1,
    DraftReady = 2,
    GameComplete = 3,
}
